/******************************************************************************************
 *	Customer Reminder Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.customerReminderModal', [])
    .factory(
      'CustomerReminderModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/customer-reminder-modal.html',
          controller: 'CustomerReminderModalController',
          classNames: 'reminder-modal'
        });
      }
    )
    .controller(
      'CustomerReminderModalController',
      /* @ngInject */
      function($log, $scope, CustomerReminderModal, CurtainNotifications, CustomerInvitation) {
        //Set initial form values
        $scope.newEmail = $scope.customer.email;
        $scope.usadEnabled = $scope.customer.usadEnabled;

        //Control vars for UI validation errors
        $scope.submitAttempted = false; //Was submit button clicked?

        var resetSubmit = function() {
          CustomerReminderModal.unsetLoadingState();
          $scope.submitted = false;
          $scope.submitAttempted = false;
        };

        $scope.submit = function() {
          if (!$scope.submitted) {
            $scope.submitAttempted = true;

            if ($scope.reminderForm.$valid) {
              $scope.submitted = true;
              CustomerReminderModal.setLoadingState();

              var payload = {
                email: $scope.newEmail,
                //Make sure usadEnabled is boolean.
                //Angular sets it to `undefined` if it was never touched.
                usadEnabled: !!$scope.usadEnabled
              };

              CustomerInvitation.updateEmail($scope.customer.id, payload)
                .then(function(responseData) {
                  CurtainNotifications.show(
                    CurtainNotifications.SUCCESS,
                    'sendReminderModal.notifications.submitSuccess',
                    {name: $scope.customer.name, email: $scope.newEmail}
                  );
                  CustomerReminderModal.remove({response: responseData});
                })
                .catch(function(response) {
                  if (response.status !== 0) {
                    //status is 0 when call is aborted
                    //Get first character from HTTP status as number
                    var statusType = +('' + response.status).charAt(0);

                    if (statusType === 4) {
                      if (response.data.errorCode === 'INVALID_EMAIL') {
                        $scope.emailIsInvalid = true;
                      } else if (response.data.errorCode === 'INVITE_ALREADY_ACCEPTED') {
                        CurtainNotifications.show(
                          CurtainNotifications.NOTICE,
                          'sendReminderModal.notifications.invitationAlreadyAccepted'
                        );

                        //Close reminder modal
                        CustomerReminderModal.remove({refreshCustomers: true});
                      } else {
                        CurtainNotifications.show(
                          CurtainNotifications.ERROR,
                          'generic.notifications.error'
                        );
                        $log.error('Failed to update customer invite email', response.data);
                      }

                      resetSubmit();
                    } else {
                      CurtainNotifications.show(
                        CurtainNotifications.ERROR,
                        'generic.notifications.error'
                      );
                      resetSubmit();
                      $log.error('Failed to update customer invite email', response.data);
                    }
                  }
                });
            }
          }
        };

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          CustomerReminderModal.remove({cancelled: true});
        };
      }
    );
})();
